import type { NavLink } from '@core/layouts/types'

export default function isNavItemActive(item: NavLink, pathname: string): boolean {
  if (!item.path) return false
  if (item.openInNewTab) return false
  if (item.alsoActiveOn?.(pathname)) return true
  if (item.exactMatch) return pathname === item.path
  // Match either an exact path or a real sub-path (`/x/y`), so links like
  // `/sites` don't accidentally activate on hypothetical sibling routes such
  // as `/sites-old`. Sibling nav items that share a true prefix still need
  // `exactMatch` on the parent to avoid both rows being active at once.
  return pathname === item.path || pathname.startsWith(`${item.path}/`)
}
